import { atom } from "recoil";

const LastFlightListCallAtom = atom<null | Date>({
    default: null,
    key: 'lastFlightListCall'
})

export default LastFlightListCallAtom;